<script setup lang="ts">
import { Wrench } from 'lucide-vue-next';
import { ref } from 'vue';

import { useEditor } from '@/composables/useEditor';

import SelectionAutoConfiguration from './SelectionAutoConfiguration.vue';
import SelectionPreview from './SelectionPreview.vue';

const { configurationAuto: config } = useEditor();

const edit = ref(false);
</script>

<template>
  <div class="selection-auto">
    <SelectionAutoConfiguration v-if="edit" @save="edit = false" />
    <SelectionPreview v-else :config @configure="edit = true">
      <template #configure-icon>
        <Wrench />
      </template>
      <template #configure-title>
        {{ $t('editor.selection.configure') }}
      </template>
    </SelectionPreview>
  </div>
</template>

<style scoped>
.selection-auto {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
</style>
